import React from "react";
import { Link } from "react-router-dom";
import "../css/App.css";

import useUtils from "./hooks/useUtils";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default (props) => {
  const pol_0km =
    props.descuentos &&
    props.descuentos.descuentos &&
    props.descuentos.descuentos[0].Pol_0km;
  const pol_0km_Gastos =
    props.descuentos &&
    props.descuentos.descuentos &&
    props.descuentos.descuentos[0].Pol_0km_Gastos;
  /*   const pol_Usados = props.descuentos.descuentos[0].Pol_Usados;
  const pol_Usados_Gastos = props.descuentos.descuentos[0].Pol_Usados_Gastos; */

  const ruta = "https://store.lenken.com.ar/img/";
  const onSeleccionVehiculo = () => {
    window.scroll({
      top: 0,
    });

    props.onSeleccionVehiculo(props.auto);
  };

  /*   function sendWhatsappFer(modelo, chasis) {
    let texto = `https://wa.me/5491151060558?text=Hola, me estoy comunicando de Prana y estoy interesado en el modelo ${modelo}, chasis ${chasis} tipo 0KM. Mi consulta es:%20`;

    window.location.href = texto;
  } */

  let leyendaPrecioDolar =
    props.auto.moneda === "U$S" ? "(Dolar Banco Nación)" : "";

  const { loadNoImage } = useUtils(props.auto.foto0);

  return (
    <>
      <div className="col s12 m4 l4 center-align">
        <div className="center-align">
          <div
            className="card hoverable"
            style={{ border: "1px solid lightGray" }}
          >
            <div className="valign-wrapper">
              <div
                className="card-image waves-effect waves-block waves-light valign-wrapper tarjeta"
                style={{ height: "13em" }}
              >
                <Link onClick={onSeleccionVehiculo} to="/fotos">
                  <img
                    className="activator"
                    src={ruta + props.auto.foto0}
                    style={{ width: "100%" }}
                    alt="auto"
                    onError={(e) => loadNoImage(e)}
                  />
                </Link>
              </div>
            </div>
            <div className="card-content" style={{ paddingTop: "0px" }}>
              <ul>
                <li
                  className="li-version truncate left-align"
                  style={{ fontSize: "25px", color: "#212529" }}
                >
                  {props.auto.version}
                </li>
                <hr />
                <li className="li-version truncate left-align">
                  {props.auto.tipo}
                </li>
                <li className="li-version truncate left-align">
                  {props.auto.anio} | {props.auto.transmision} |{" "}
                  {props.auto.kms}
                  km
                </li>
                <li
                  className="li-version truncate left-align"
                  style={{
                    marginTop: "15px",
                    fontSize: "17px",
                    color: "#212529",
                    fontFamily: "Audi Normal",
                    fontWeight: "bold",
                  }}
                >
                  {props.auto.moneda === "u$d" ? "USD " : "$ "}
                  {Intl.NumberFormat("es-AR", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).format(props.auto.precio)}
                </li>
                {/*        <li className="li-version truncate left-align">
              <span style={{ color: "red", fontWeight: "bold" }}>
                DESCUENTO ONLINE <br></br>
                {Intl.NumberFormat("es-AR", {
                  style: "currency",
                  currency: "ARS",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(
                  props.auto.precio * pol_0km +
                    props.auto.pat_emp * pol_0km_Gastos
                )}
              </span>
            </li> */}
                <li
                  className="li-version truncate left-align"
                  style={{ fontWeight: "bold", fontSize: "12px" }}
                >
                  {leyendaPrecioDolar}
                </li>
              </ul>
              <div class="row">
                <Link
                  className="hoverable white-text left"
                  style={{
                    padding: "5px 10px 28px 10px",
                    height: "30px",
                    marginTop: "5px",
                    marginLeft: "10px",
                    fontFamily: "Audi Extended",
                    backgroundColor: "black",
                  }}
                  onClick={onSeleccionVehiculo}
                  to="/gastos"
                >
                  <b>reservar</b>
                </Link>
                <a
                  className="waves-effect hoverable left"
                  style={{
                    marginTop: "5px",
                    border: "1px solid black",
                    padding: "5px 10px 26px 10px",
                    height: "30px",
                    fontFamily: "Audi Extended",
                    color: "black",
                  }}
                  href="https://wa.me/5491145058666?text=Hola,%20me%20estoy%20comunicando%20desde%20la%20seccion%200km.%20Mi%20consulta%20es:%20"
                >
                  contactar
                </a>
                <a
                  href={`https://wa.me?text=El link para compartir este producto es: https://store.lenken.com.ar/vtf/?compartir=${props.auto.id}`}
                  data-action="share/whatsapp/share"
                >
                  <FontAwesomeIcon
                    icon="share"
                    style={{ color: "black", paddingTop: "15px" }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
